<template>
    <v-card>
        <v-card-title class="headline" style="border-bottom-style: outset;border-bottom-width: 1px;"> Notificaciones </v-card-title>
        <template v-if="notifications.length > 0">
            <app-modal-row  v-for="noti in notifications" style="border-bottom-style: outset;border-bottom-width: 1px;">
                <app-modal-col cols='11'>
                    
                    <v-card-text>
                    <b style="font-size:large">  {{noti.subject}} </b> <br><br>
                        <div v-html="noti.date"></div>
                        <div v-html="noti.message"></div>
                    </v-card-text>
                </app-modal-col>
                <app-modal-col cols='1'>
                    <v-btn @click="delete_noti(noti.id)"
                            icon 
                            large
                            style="bottom:-10px"
                            color="primary"
                            :loading="loading.includes(noti.id)"
                            >
                        Leído
                    </v-btn>
                </app-modal-col>
            </app-modal-row>
        </template>
        <template v-else>
            <v-card-text>
                No hay notificaciones.
            </v-card-text>
        </template>
    </v-card>
</template>

<script>

import { mapActions, mapGetters } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';

export default {
    name: 'NotificationsPopup',
    components: {
        AppModalCol,
        AppModalContainer,
        AppModalRow
    },
    props: {

    },
    data () {
        return {
            loading:[],
        }
    },
    methods: {
        ...mapActions({
            removeNotification: "notifications/removeNotification",
        }),

        delete_noti(noti_id){
            this.loading.push(noti_id)
            let user_id = this.userData.user
            this.removeNotification({user_id,noti_id})
            this.loading = this.loading.filter(i => i !== noti_id)
        }
    },
    computed: {
        ...mapFields('notifications', ['notifications']),
        ...mapGetters({userData: 'me/userData'})
        
    },
}
</script>

<style lang="scss" scoped>

span.title {
    color: #66369b
}

.plans {
    cursor: pointer;
    font-size: 0.80rem;
    background-color:white;
    &.selected {
        background-color: #dedcff;
    }
    &.disabled {
        opacity: 50%;
    }
    span {
        margin: auto;
    }
    border: 1px solid #66369b;
}
button.btn-purple {
    color: #ffffff;
}


p.contract-date {
    color: #66369b;
    font-weight: 500;
    font-size: 0.9rem;
    text-align: left;
}


.small-font {
    font-size: 0.80rem;
}

.promotional_code fieldset {
    color: white !important;
}


</style>